<template>
  <b-modal
    :title="`Rescatar Expediente ${file.numero}`"
    v-model="showModal"
    centered
    hide-footer
  >
    <div>
      Al rescatar este documento, se desestimará el flujo de aprobaciones relacionado y
      el expediente volverá a estado borrador, ¿estás de acuerdo?
    </div>
    <div class="chip-custom">
      ¡Al realizar esta acción se notificará a todos lo que ya
      participaron del flujo de aprobaciones!
    </div>
    <div class="wrap-commentary">
      <vs-textarea
        data-cy="write-comment"
        maxlength="255"
        label="Comentario"
        v-model="comment"
      />
      <div v-if="notValid">
        <small style="color: red;">
          No has ingresado un comentario para validar esta acción
        </small>
      </div>
    </div>
    <div class="m-top-20" style="display: flex;justify-content: flex-end;">
      <vs-button
      data-cy="cancel"
      color="dark"
      v-on:click="cancelProcess()"
      type="border">Cancelar
      </vs-button>
      <vs-button
        data-cy="yes-archive"
        v-on:click="processFile()"
        color="primary"
        style="margin-left: 12px;"
        type="border"
      >
        Si, rescatar
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { clRecoverFile } from '@/febos/servicios/api/dnt.api';

export default {
  name: 'PopUpRecoverFile',
  data() {
    return {
      comment: '',
      notValid: false
    };
  },
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  watch: {
    comment() {
      this.notValid = false;
    },
    processedFile() {
      this.notValid = false;
      this.comment = '';
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'recoverFile';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async processFile() {
      this.notValid = false;
      if (this.comment === '') {
        this.notValid = true;
        return;
      }
      await clRecoverFile({
        febosId: this.file.febosId,
        message: this.comment
      });
      await this.$bvToast.toast(
        'Se ha rescatado el expediente con éxito',
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      await this.$router.push({ name: 'files', params: { view: 'borradores' } });
    },
    cancelProcess() {
      this.notValid = false;
      this.closeModal();
    }
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}
</style>
